import {
    ComplectationOptionsUICreateForm,
    makeComplectationEmptyUICreateForm,
    mapComplectationUICreateFormToRequestCreateForm,
} from '@/types/complectation/complectation-ui-create-form.type.ts';
import { ComplectationUpdateForm } from '@/types/complectation/complectation-update-form.type.ts';
import { Complectation } from '@/types/complectation/complectation.type.ts';
import { ComplectationOption } from '@/types/complectation/complectation-option.type.ts';

export type ComplectationOptionsUIUpdateForm = ComplectationOptionsUICreateForm;

export type ComplectationUIUpdateForm = {
    model_id?: number,
    code: string,
    complectation_option: ComplectationOptionsUIUpdateForm,
};

export function makeComplectationEmptyUIUpdateForm(): ComplectationUIUpdateForm {
    return makeComplectationEmptyUICreateForm();
}

export function mapComplectationUIUpdateFormToRequestUpdateForm(uiUpdateForm: ComplectationUIUpdateForm): ComplectationUpdateForm {
    return mapComplectationUICreateFormToRequestCreateForm(uiUpdateForm);
}

export function fillComplectationUIUpdateFormFromRequestComplectation(complectation: Complectation): ComplectationUIUpdateForm {
    const uiUpdateForm: ComplectationUIUpdateForm = makeComplectationEmptyUIUpdateForm();

    uiUpdateForm.model_id = complectation.model_id;
    uiUpdateForm.code = complectation.code;

    const filledOptions: Record<string, string | boolean> = {};
    complectation.options?.forEach((option: ComplectationOption) => {
        const code = option.option_symbolic_code as keyof ComplectationOptionsUIUpdateForm;
        filledOptions[code] = complectationOptionRawValueToUIFormValue(
            option.option_symbolic_code,
            option.option_value_symbolic_code,
        );
    });

    uiUpdateForm.complectation_option = { ...uiUpdateForm.complectation_option, ...filledOptions };

    return uiUpdateForm;
}

export function complectationOptionRawValueToUIFormValue(code: string, value: string): any {
    switch (code) {
        case 'abs':
        case 'all_round_camera':
        case 'auto_parking_system':
        case 'aux':
        case 'blind_spot_monitoring':
        case 'bluetooth':
        case 'central_locking':
        case 'collision_avoidance_system':
        case 'combination_skin':
        case 'conditioner':
        case 'cruise_control':
        case 'driver_knee_airbag':
        case 'driver_tracking_system':
        case 'ebd':
        case 'electric_driver_seat':
        case 'electric_passenger_seat':
        case 'emergency_brake_assist':
        case 'fog_lights':
        case 'front_airbags':
        case 'front_parking_sensors':
        case 'glonass':
        case 'hac':
        case 'headlight_washer':
        case 'heated_seats':
        case 'heated_wheel':
        case 'hold_lane_assist':
        case 'immobilizer':
        case 'isofix':
        case 'leather_gearshift':
        case 'leather_wheel':
        case 'light_sensor':
        case 'memory_settings':
        case 'multifunction_steering_wheel':
        case 'native_navigation_system':
        case 'panoramic_roof':
        case 'part_folding_baskrest':
        case 'power_heated_mirrors':
        case 'power_tailgate':
        case 'power_windows':
        case 'rain_sensor':
        case 'rear_door_lock':
        case 'rear_parking_sensors':
        case 'rear_view_camera':
        case 'roof_rails':
        case 'running_lights':
        case 'safety_shutters':
        case 'seat_ventilation':
        case 'side_airbags':
        case 'signalling':
        case 'smart_key':
        case 'socket_12v':
        case 'socket_220v':
        case 'tcs':
        case 'tire_pressure_monitoring':
        case 'usb':
            return value === 'yes';
    }

    return value;
}
